import React from "react";
import styles from "./Styles";
import { Card, CardContent, Typography, List } from "@material-ui/core";
import ListItem from "@material-ui/core/ListItem";
import { Link } from "react-admin";
import { canAccess } from "../../rbac";

const TOURS_ITEMS = [
  { to: "/tour-management", text: "Pending tour Bookings", permission: "tour_management" },
  { to: "/tour_due_list", text: "Tours Due", permission: "tour_due_list" },
  { to: "/tour_list", text: "Tour List", permission: "tour_list" },
  { to: "/tours", text: "Tours Whiteboard", permission: "tours" },
  { to: "/tour_guides", text: "Tour Guides", permission: "tour_guides" },
  { to: "/tour_bikes", text: "Guide Bikes", permission: "tour_bikes" },
  { to: "/tour_gps_devices", text: "Guide GPSs", permission: "tour_gps_devices" },
  { to: "/tour_vans", text: "Guide Vans", permission: "tour_vans" },
];

export class ToursOptions extends React.Component {
  render() {
    return (
      <Card style={styles.cardStyle}>
        <Typography
          gutterBottom
          variant="h6"
          component="h2"
          style={styles.cardHeaderStyle}
        >
          Tours
        </Typography>
        <CardContent style={styles.CardContent}>
          <List>
            {TOURS_ITEMS.map(({ to, text, permission }) =>
              canAccess(permission) ? (
                <ListItem key={to}>
                  <Link to={to}>{text}</Link>
                </ListItem>
              ) : null
            )}
          </List>
        </CardContent>
      </Card>
    );
  }
}

export default ToursOptions;



// WEBPACK FOOTER //
// ./src/components/dashboard/ToursOptions.js